import { render, staticRenderFns } from "./log-setting.vue?vue&type=template&id=408bff7f&scoped=true"
import script from "./log-setting.vue?vue&type=script&lang=js"
export * from "./log-setting.vue?vue&type=script&lang=js"
import style0 from "./log-setting.vue?vue&type=style&index=0&id=408bff7f&prod&lang=less&scoped=true"
import style1 from "./log-setting.vue?vue&type=style&index=1&id=408bff7f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408bff7f",
  null
  
)

export default component.exports